import React from "react";
import { Check } from "lucide-react";

// Elenco di ciò che si sblocca, condiviso da Paywall.jsx (muro all'avvio di un nuovo
// screening) e UpgradeDialog.jsx (rete di sicurezza al download). Entrambi chiedono lo stesso
// importo e ricevono le stesse voci `upg_f*`: due paywall che vendono cose diverse allo stesso
// prezzo sono un problema di credibilità.
export const UnlockIncludes = ({ items }) => (
  <ul className="space-y-3">
    {items.map((f, i) => (
      <li key={i} className="flex items-start gap-3 text-sm text-slate-700">
        <span className="mt-0.5 w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center flex-shrink-0">
          <Check className="w-3.5 h-3.5" strokeWidth={2.5} />
        </span>{f}
      </li>
    ))}
  </ul>
);
